import { useMutation } from 'react-query';
import tasksServices from './tasks.services';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';

export default function useChatApiTaskFeedback() {
  return useMutation({
    mutationFn: tasksServices.taskFeedback,
    onSuccess() {
      notification.success({ message: 'Enviado o feedback do chamado' });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
